const styleSheet = (theme: any) => ({
  backgroundContainer: {
    backgroundColor: '#FFFFFF',
    paddingTop: '25px',
    position: 'relative',
    paddingLeft: '48.5px',
  },
  inputHider: {
    width: '1012px',
    height: '47px',
    zIndex: 8,
    position: 'relative',
    marginBottom: '-45px',
    backgroundColor: '#FFFFFF',
  },
  loader: {
    width: '987px',
    height: '1400px',
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    zIndex: 9,
  },
  dropdownTitle: {
    position: 'absolute',
    top: '36px',
    right: '0px',
    height: '12px',
    width: '167px',
    color: '#6E7680',
    fontFamily: 'Avenir',
    fontSize: '9px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '12px',
  },
  dropdownContainer: {
    position: 'absolute',
  },
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/dashboards/YourEDUVSNetwork/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/containers/GoodData/dashboards/YourEDUVSNetwork/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }